import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';
import { formatNumber } from '~/lib';

export default function PriceSection({
  price,
  labelKey,
}: {
  price?: number;
  labelKey: string;
}) {
  const { mobileScreen } = useBreakpoint();
  const { t } = useTranslation('app');

  return (
    <div className="flex  items-center gap-x ">
      <Icon
        name="money"
        size={mobileScreen ? '32px' : '40px'}
        className="text-gray__dark_2 "
      />
      <div className="flex flex-col gap-x">
        <span className="text-body_2 text-gray__dark_2">{t(labelKey)}</span>
        <span className="text-title_4 flex items-center gap-1">
          <span>{price ? formatNumber(price) : '---'}</span>
          {price ? (
            <span className="text-link">
              {labelKey === 'averagePricePerMeter'
                ? t('pricePerMeterUnit')
                : t('egp')}
            </span>
          ) : (
            ''
          )}
        </span>
      </div>
    </div>
  );
}
